export default __webpack_public_path__ + "static/media/fauna-dashboard-th.e2e5943d.png";